import { useEffect } from 'react';
import { useAuth } from '../../../contexts/AuthProvider';
import { RestApi } from '../../../services/rest-api';
import { Button, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { IField } from '../../../interfaces/field.interface';
import { useUtility } from '../../../contexts/UtilityContext';
import { Fields } from '../../../components/Fields';
import { YES_NO_OPTIONS } from '../../../constants/config';
import { BrandModel } from '../../../model/brand.model';

interface IOwnProps {
  brand?: BrandModel;
  onSuccess: (brand: BrandModel) => void;
}

export const BrandForm: React.FC<IOwnProps> = (props) => {
  const { authInfo } = useAuth();
  const { showLoader, hideLoader, toast } = useUtility();

  const fields: Array<IField> = [
    {
      label: "Brand Name",
      required: true,
      props: {
        name: "brand_name",
        type: "text",
        inputMode: "text",
        placeholder: "Brand Name",
      }
    }, {
      label: "Publish",
      required: true,
      props: {
        name: "publish",
        type: "select",
        placeholder: "Publish"
      },
      options: YES_NO_OPTIONS,
    }
  ];

  const { register, control, handleSubmit, reset } = useForm<BrandModel>({
    defaultValues: {},
    mode: "onTouched",
    reValidateMode: "onChange"
  });

  useEffect(() => {
    async function fetchData() {
      try {
        if (props.brand) {
          showLoader();
          reset({
            ...props.brand,
          });
        }
      } catch (err) {
        console.log(err);
      } finally {
        hideLoader();
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.brand, reset]);

  const onSubmit = handleSubmit(async (inputs) => {
    try {
      showLoader();
      const res = await RestApi<BrandModel>('post', props.brand?.id ? 'updateBrand' : 'createBrand', {
        ...inputs,
        ...(props ? { id: props.brand?.id } : {}),
      }, authInfo.user.authorization);

      props.onSuccess(res);

    } catch (message) {
      toast(message, 'danger');
    } finally {
      hideLoader();
    }
  });

  return (
    <Form onSubmit={onSubmit} noValidate>
      <div>
        <Fields<BrandModel> fields={fields} control={control} register={register} />
      </div>
      <Button className='w-100 mt-3' variant='primary' type="submit">Submit</Button>
    </Form>
  );
};